import { CONST } from "../../CONST";
import { GridFillScene } from "../../scenes/GridFillScene";
import { Shape, ShapeConfig} from "./Shape";


export interface GridConfig {
    g: number[][],
    b: number[][],
    n: string,
}



export default class GridManager {
    private scene: GridFillScene;
    private position: {x: number, y: number};
    private cellSize: number;
    private rowCount !: number;
    private columnCount !: number;
    private gridName!: string;

    private gridBg !: Phaser.GameObjects.Grid;
    private imageBg !: Phaser.GameObjects.Image;
    private gridOrigin !: Phaser.Math.Vector2;

    private shapes !: Shape[];

    private occupancyMap : any;

    private shapeConfig: ShapeConfig[];

    private availableBlockColors = [CONST.GRID_FILL.BLOCK_BLUE, CONST.GRID_FILL.BLOCK_GREEN, CONST.GRID_FILL.BLOCK_ORANGE, CONST.GRID_FILL.BLOCK_PURPLE, CONST.GRID_FILL.BLOCK_RED, CONST.GRID_FILL.BLOCK_YELLOW];

    //TODO delete those
    // private debugOccupancy: number[][] = [[],[],[],[],[],[],];
    // private maxGrid = 0;
    // private debugBlockColors = [CONST.GRID_FILL.BLOCK_BLUE, CONST.GRID_FILL.BLOCK_GREEN, CONST.GRID_FILL.BLOCK_ORANGE, CONST.GRID_FILL.BLOCK_PURPLE, CONST.GRID_FILL.BLOCK_RED, CONST.GRID_FILL.BLOCK_YELLOW];


   constructor(scene: GridFillScene, position: {x: number, y: number}, gridConfig : GridConfig, gridSizeInfo: {yOffset: number, cellSize: number}[]){
        this.scene = scene;
        this.position = position;

        this.shapeConfig = this.interpretGridConfig(gridConfig);
        this.occupancyMap = [];

        this.cellSize = gridSizeInfo[this.rowCount].cellSize;
        this.position.y += gridSizeInfo[this.rowCount].yOffset;

        // this.scene.events.on('update', this.debugUpdate, this);
   }

   //TODO: delete this
//    private debugUpdate(){
//        var pointerPos = this.scene.input.activePointer.position;
//        var pointerGridPos = this.debugWorldToGridPos({x: pointerPos.x, y: pointerPos.y});

      
//         var key6 = this.scene.input.keyboard.addKey("SIX");
//         var key1 = this.scene.input.keyboard.addKey("ONE");
//         var key2 = this.scene.input.keyboard.addKey("TWO");
//         var key3 = this.scene.input.keyboard.addKey("THREE");
//         var key4 = this.scene.input.keyboard.addKey("FOUR");
//         var key5 = this.scene.input.keyboard.addKey("FIVE");

//         this.updateDebugOccupancy(key6, pointerGridPos, 5);
//         this.updateDebugOccupancy(key1, pointerGridPos, 0);
//         this.updateDebugOccupancy(key2, pointerGridPos, 1);
//         this.updateDebugOccupancy(key3, pointerGridPos, 2);
//         this.updateDebugOccupancy(key4, pointerGridPos, 3);
//         this.updateDebugOccupancy(key5, pointerGridPos, 4);
//    }
   
//    //TODO: delete this
//    private updateDebugOccupancy(key: any, pointerGridPos: any, value: number){
//     if (key.isDown){
//         if (!this.debugOccupancy[pointerGridPos.y]) this.debugOccupancy[pointerGridPos.y] = [];
//         if (this.debugOccupancy[pointerGridPos.y][pointerGridPos.x] != value){
//             this.debugOccupancy[pointerGridPos.y][pointerGridPos.x] = value;  

//             var worlPos = this.gridToWorldPosition({x: pointerGridPos.x + 0.5, y: pointerGridPos.y + 0.5});
//             this.scene.add.image(worlPos.x, worlPos.y, this.debugBlockColors[value]).setDepth(1000).setDisplaySize(this.cellSize, this.cellSize);
//             if (value > this.maxGrid) this.maxGrid = value;
//             this.debugPrintGridConfig();
//         }
//     }
//    }

//    //TODO: delete this
//    private debugWorldToGridPos(pos: {x: integer, y: integer}){
//         return new Phaser.Math.Vector2(Math.floor((pos.x - this.gridOrigin.x ) / this.cellSize),Math.floor((pos.y - this.gridOrigin.y ) / this.cellSize));
//     }

//     private debugPrintGridConfig(){
//         let arr = this.debugOccupancy.filter(function (el) {
//             return el.length > 0;
//           });

//         var string = "{\n       n: \"\",\n       g: " + JSON.stringify(arr) + ",\n       b: [[0,0]";
//         for (var i = 0; i < this.maxGrid; i++){
//             string += ",[0, 0]";
//         }
//         string += "],\n},";
//         console.log(string);
//     }

   private interpretGridConfig(gridSetup: GridConfig){
    this.availableBlockColors = [...Phaser.Utils.Array.Shuffle(this.availableBlockColors)];

        var shapeConfigs = [];

        let grid = gridSetup.g;
        
        let blockStartPositions = gridSetup.b;

        let name = gridSetup.n;

        //console.warn("Grid name: " + name);
        
        
        for (let i = 0; i < blockStartPositions.length; i++){
            let config: ShapeConfig = {
                blocks: [],
                startPos: {x: blockStartPositions[i][0], y: blockStartPositions[i][1] },
                blockColor: this.getRandomBlockColor(),
            }
            shapeConfigs[i] = config;
        }

        //loop over the whole grid
        for (let i = 0; i < grid.length; i++){
            for (let j = 0; j < grid[i].length; j++){
                let currShape = grid[i][j];
                    shapeConfigs[currShape].blocks.push({gridOffset: {x: j, y: i}});                
            }
        }

        this.rowCount = grid.length;
        this.columnCount = grid[0].length;
        this.gridName = name;

        return shapeConfigs;
    }

    private getRandomBlockColor(): string{
        let blockColor = this.availableBlockColors.pop();
        return blockColor ? blockColor : CONST.GRID_FILL.BLOCK_BLUE;
    }

   public createGrid(){

        this.gridBg = this.scene.add.grid(this.position.x, this.position.y, this.columnCount * this.cellSize, this.rowCount * this.cellSize, this.cellSize, this.cellSize, 0x757474)
            //.setAltFillStyle(0x919191)
            //.setOutlineStyle()
            .setDepth(11);

        this.imageBg = this.scene.add.image(this.position.x, this.position.y, CONST.GRID_FILL.SCREEN)
                            .setDepth(10)
                            .setDisplaySize(this.columnCount*this.cellSize + 5, this.rowCount*this.cellSize + 5);

        this.gridOrigin = this.gridBg.getTopLeft();

        this.shapes = [];
        this.shapeConfig.forEach((config) => { this.shapes.push(new Shape (this.scene, config, this)) } );
   }

   public getCellSize(){
       return this.cellSize;
   }

   public getGridOrigin(){
       return this.gridOrigin;
   }

   public gridToWorldPosition(pos: {x: integer, y: integer}){
        return new Phaser.Math.Vector2(this.gridOrigin.x + pos.x * this.cellSize, this.gridOrigin.y + pos.y * this.cellSize);
   }

   public isGridPosValid(pos: {x: integer, y: integer}, shape: Shape){
        //Check if shape is colliding with any other shapes
        return !shape.getBlocks().some(block => {
            let blockPos = {x: pos.x + block.config.gridOffset.x, y: pos.y + block.config.gridOffset.y };
            return this.occupancyMap[blockPos.x.toString() + blockPos.y.toString()];
        });
   }


   public updateOccupancyMap(shape:Shape, occupiesSpace: boolean){
       shape.getBlocks().forEach(block => { 
           let pos = block.getGridPos();
           this.occupancyMap[pos.x.toString()+pos.y.toString()] = occupiesSpace;
       });
   }

   public checkForBoardCompleted(){
       if (this.isBoardCompleted()){
           this.scene.onLevelCompleted();
       }
   }

   public handleLevelCompleted(){
    this.shapes.forEach(shape => shape.fadeOut());
   }

   private isBoardCompleted(){
    for (let i = 0; i < this.columnCount; i++){
        for (let j = 0; j < this.rowCount; j++){
            if (!this.occupancyMap[i.toString()+j.toString()]){
                return false;
            }
        }
    }
    return true;
   }

   public onGameLost(){
       this.shapes.forEach(shape => shape.onGameLost());
   }

   public destroy(){
        this.gridBg.destroy();
        this.imageBg.destroy();
        this.shapes.forEach(shape => shape.destroy());
   }

   public getGridName(){
       return this.gridName;
   }

//    public debugLogShapePositions(){
//       let string = "b: [";
//       this.shapes.forEach(s => {
//           let gridpos = s.getGridPosition();
//             string += "["+gridpos.x+","+gridpos.y+"]";
//             if (this.shapes.indexOf(s) != this.shapes.length - 1){
//                 string += ", ";
//             }
//         });
//         string += "],"

//         console.log(string);
//       //        b: [[5,6], [1,6], [-6,4], [-3,6]]

//    }
}